import * as React from 'react';
import { useOrder, createContainsHelper } from '@grandvisionhq/fun-orders';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useLocalStorage } from '@grandvisionhq/lib-utils-w3c';
import { useIntl } from '@grandvisionhq/state';
import { useSessionStorage } from '@grandvisionhq/utils';
import { pushPurchaseEventToDataLayer, trackOrderCompletionEvents } from '../data-layer.js';
import { SHIPPING_STATE_KEY } from '../LoginExpressCheckout/models/shippingTypes.js';
import { USER_DETAILS_STATE_KEY } from '../LoginExpressCheckout/models/user-details-types.js';
import { useOrderConfirmLabels } from './hooks/use-order-confirm-labels.js';
import { useOrderConfirmTealiumEvent } from './hooks/use-order-confirm-tealium-event.js';
import { OrderConfirm } from './OrderConfirm.js';

const OrderConfirmContainerV2 = ({ logo , orderData: orderToken , cartId , checkoutMethod ='regular_checkout' , isTrustedShopsCheckout  })=>{
    const [, { reset  }] = useCartStorage();
    const { getOrderByToken , order , error , loading  } = useOrder();
    const { handleOrderConfirmPageEventDispatch  } = useOrderConfirmTealiumEvent();
    const labels = useOrderConfirmLabels(order);
    const { currency  } = useIntl();
    const [, , removeShippingState] = useLocalStorage(SHIPPING_STATE_KEY, null);
    const [, , removeUserDetailsState] = useLocalStorage(USER_DETAILS_STATE_KEY, null);
    const [, removeAdyenPaymentConfiguration] = useSessionStorage('payment-configuration', undefined, (value)=>value === undefined
    );
    const contains = React.useMemo(()=>{
        return createContainsHelper(order === null || order === void 0 ? void 0 : order.lineItems);
    }, [
        order === null || order === void 0 ? void 0 : order.lineItems
    ]);
    const onCompleted = React.useCallback(()=>{
        reset();
        removeShippingState();
        removeUserDetailsState();
        removeAdyenPaymentConfiguration(undefined);
    }, [
        removeAdyenPaymentConfiguration,
        removeShippingState,
        removeUserDetailsState,
        reset
    ]);
    React.useEffect(()=>{
        if (orderToken) {
            getOrderByToken(orderToken, onCompleted);
        }
    // Only `orderToken` needed in the dep. array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderToken
    ]);
    React.useEffect(()=>{
        if (order) {
            var ref;
            if (order.donationIntent && ((ref = order.donation) === null || ref === void 0 ? void 0 : ref.amount)) {
                pushPurchaseEventToDataLayer(order, currency, cartId, checkoutMethod, {
                    foundationKey: order.donationIntent.foundationKey,
                    centAmount: order.donation.amount
                });
            } else {
                pushPurchaseEventToDataLayer(order, currency, cartId, checkoutMethod);
            }
            trackOrderCompletionEvents(order, currency);
            handleOrderConfirmPageEventDispatch(order);
        }
    }, [
        cartId,
        currency,
        order,
        handleOrderConfirmPageEventDispatch,
        checkoutMethod
    ]);
    return /*#__PURE__*/ React.createElement(OrderConfirm, {
        order: order,
        logo: logo,
        labels: labels,
        contains: contains,
        error: error,
        isLoading: loading,
        isTrustedShopsCheckout: isTrustedShopsCheckout
    });
};

export { OrderConfirmContainerV2 };
//# sourceMappingURL=OrderConfirmContainerV2.js.map
